import { Package } from "lucide-react";

type ToolsEmptyStateProps = {
  hasFilters: boolean;
};

export const ToolsEmptyState = ({ hasFilters }: ToolsEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center rounded-lg border border-dashed bg-muted/25 py-16 text-center">
    <div className="mb-4 flex size-14 items-center justify-center rounded-full bg-muted">
      <Package className="size-7 text-muted-foreground" />
    </div>
    <h3 className="font-medium text-foreground text-lg">No tools found</h3>
    <p className="mt-1.5 max-w-sm text-muted-foreground text-sm">
      {hasFilters
        ? "Try adjusting your search or filters to find what you're looking for."
        : "There are no tools available at the moment."}
    </p>
  </div>
);
